import { useEffect, useState } from "react";
import api from "./api";

// Etichetta del provider WhatsApp attivo nel circuito ("Meta" oppure "Spoki"), con cache in memoria
let cached = null;
let pending = null;
const listeners = new Set();

export const labelFor = (p) => (p === "cloud" ? "Meta" : "Spoki");

export function setWaProviderCache(p) {
  cached = p;
  listeners.forEach((fn) => fn(p));
}

export function useWaProvider() {
  const [provider, setProvider] = useState(cached);
  useEffect(() => {
    listeners.add(setProvider);
    if (cached === null && !pending) {
      pending = api.get("/whatsapp/provider").then(({ data }) => setWaProviderCache(data.provider || "spoki")).catch(() => setWaProviderCache("spoki")).finally(() => { pending = null; });
    }
    return () => listeners.delete(setProvider);
  }, []);
  return { provider: provider || "spoki", label: labelFor(provider || "spoki"), isMeta: provider === "cloud" };
}
